import { useState } from 'react';
import { useToast, ToastType } from 'services/toast';
import { getCampaign, launchCampaign as launchCampaignApi } from './api';

import { useQuery } from 'services/api/hooks';
import { Campaign as CampaignType } from './types';

const useCampaign = ({
  campaignId,
  onLaunchCampaignSuccess
}: {
  campaignId: string;
  onLaunchCampaignSuccess?: (campaignId: string) => void;
}) => {
  const [isLaunching, setIsLaunching] = useState(false);
  const [campaign, setCampaign] = useState<CampaignType | null>(null);
  const { showToast } = useToast();

  const { isLoading, refetch: refetchCampaign } = useQuery<CampaignType>(
    getCampaign,
    {
      id: campaignId
    },
    {
      onFetchSuccess: (data) => {
        setCampaign(data);
      }
    }
  );

  const launchCampaign = async ({
    launchScheduleDateTime
  }: {
    launchScheduleDateTime: string | undefined;
  }): Promise<boolean> => {
    if (!campaign?.id) {
      return false;
    }

    setIsLaunching(true);
    try {
      await launchCampaignApi({
        campaignId: campaign.id,
        launchScheduleDateTime
      });

      const message = launchScheduleDateTime
        ? 'Campaign successfully scheduled'
        : 'Campaign successfully launched';
      showToast({ message, type: ToastType.Success });
      onLaunchCampaignSuccess?.(campaign.id);
      return true;
    } catch (e) {
      showToast({
        message: 'We could not launch this campaign. Please try again later',
        type: ToastType.Error
      });
      return false;
    } finally {
      setIsLaunching(false);
    }
  };

  return {
    launchCampaign,
    campaign,
    isLoading,
    refetchCampaign,
    isLaunching,
    setCampaign
  };
};

export { useCampaign };
